import { useCallback, useRef, useState } from 'react';

import type { TreatmentPlanV3AssessmentReadinessItemPayload } from '../../../../../../store/treatmentPlanV3';
import type { SaveAssessmentReadinessItemParams } from './types';

export default function useSaveAssessmentReadinessItem({
  itemId,
  onUpdateItem,
}: SaveAssessmentReadinessItemParams) {
  const [isSaving, setIsSaving] = useState(false);
  const savingPromiseRef = useRef(Promise.resolve());

  const saveItem = useCallback(
    async (data: TreatmentPlanV3AssessmentReadinessItemPayload) => {
      setIsSaving(true);
      const currentSave = savingPromiseRef.current
        .catch(() => undefined)
        .then(async () => {
          await onUpdateItem(itemId, data);
        });
      savingPromiseRef.current = currentSave;
      try {
        await currentSave;
      } finally {
        if (savingPromiseRef.current === currentSave) {
          setIsSaving(false);
        }
      }
    },
    [itemId, onUpdateItem],
  );

  return { isSaving, saveItem };
}
